export default __webpack_public_path__ + "assets/h5.d52d7b11.svg";